<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'
import type { MapMarker } from '@/composables/useRestaurants'

defineProps<Props>()

const emit = defineEmits<{
  select: []
}>()

const { t } = useI18n()

/** Строка филиала 358×73: имя 16 SemiBold, время работы 14 Medium серым, шеврон 24. */
interface Props {
  branch: MapMarker
  active?: boolean
}

</script>

<template>
  <button
    type="button"
    class="branch-row"
    :class="{ 'branch-row--active': active }"
    @click="emit('select')"
  >
    <span class="branch-row__text">
      <span class="branch-row__name font-16-s">{{ branch.title }}</span>
      <span v-if="branch.workTime" class="branch-row__time font-14-m">
        {{ t('branch.workTime') }} {{ branch.workTime }}
      </span>
    </span>

    <span class="branch-row__chevron">
      <AppIcon name="arrow-right" :size="14" />
    </span>
  </button>
</template>

<style scoped lang="scss">
.branch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  height: 73px;
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
  cursor: pointer;

  /* Имя и время идут вплотную: 24 + 21 = 45, по 14px воздуха сверху и снизу */
  &__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__name {
    overflow: hidden;
    line-height: 24px;
    color: var(--text-color);
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__time {
    line-height: 21px;
    color: var(--text-color-secondary);
  }

  /* Шеврон на плашке 24×24 r10 — как в макете */
  &__chevron {
    display: flex;
    flex: 0 0 24px;
    align-items: center;
    justify-content: center;
    height: 24px;
    border-radius: var(--radius-s);
    background: var(--surface-muted);
    color: var(--icon-color);
  }

  &--active &__name {
    color: var(--primary-500);
  }
}
</style>
